<template>
    <div class="avatar">
        <el-image :style="{width: props.size + 'px', height: props.size + 'px'}" :src="src" alt="avatar" />
        <slot name="icon-prefix"></slot>
    </div>
</template>

<script setup lang="ts">
import useUserStore from '@/store/modules/user'
interface IUserAvatar {
    size?: number
}
const props = defineProps<IUserAvatar>()
const { userInfo } = storeToRefs(useUserStore())

const src = computed(() => {
    if(userInfo.value?.userAvatar){
        return userInfo.value?.userAvatar
    }else{
        if (userInfo.value?.bizTeamMemberRole == 1) {
            return new URL('@/assets/images/account/create_avatar@2x.png', import.meta.url).href
        }else if (userInfo.value?.bizTeamMemberRole == 2) {
            return new URL('@/assets/images/account/manage_avatar@2x.png', import.meta.url).href
        }else if (userInfo.value?.bizTeamMemberRole == 3) {
            return new URL('@/assets/images/account/member_avatar@2x.png', import.meta.url).href
        }
        return new URL('@/assets/images/default_avatar@2x.png', import.meta.url).href
    }
})
</script>

<style scoped lang="scss">
.avatar{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 50%;
    cursor: pointer;
}
</style>

